export const shortenAddress = (address?: string, digits: number = 4): string | undefined => {
  const digitsBefore = digits + 2 // add 2 to account for 0x...
  if (!address) return undefined
  return address.slice(0, digitsBefore) + ".." + address.slice(address.length - digits, address.length)
}
